/*
 * Copyright (C) 2014 Spanning Cloud Apps. LLC  All rights reserved.
 */
/**
 * Date store implementation of the PickerStore.
 */
'use strict';

angular
  .module('stores.picker.date', [])
  .factory('DatePickerStore', function (PickerStore, httpBatch, batchUtils, $filter) {
    /**
     * The DatePickerStore.  It will create a picker store specific to a batch/basic picker.
     * @constructor
     */
    var DatePickerStore = function () {
      PickerStore.apply(this, arguments);
      this.nextTooltipText = $filter('i18n')('NEXT_BACKUP');
      this.previousTooltipText = $filter('i18n')('PREVIOUS_BACKUP');
    };

    DatePickerStore.prototype = new PickerStore();
    DatePickerStore.prototype.name = 'DatePickerStore';

    return DatePickerStore;
  });
